import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'sonner';
import { AuthProvider, useAuth } from './lib/auth';
import { PWAInstallPrompt } from './components/PWAInstallPrompt';
import Landing from './pages/Landing';
import Checkout from './pages/Checkout';
import CheckoutSuccess from './pages/CheckoutSuccess';
import Login from './pages/Login';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import Onboarding from './pages/Onboarding';
import AppShell from './pages/app/AppShell';
import Dashboard from './pages/app/Dashboard';
import Preventivi from './pages/app/Preventivi';
import SAL from './pages/app/SAL';
import Sicurezza from './pages/app/Sicurezza';
import Subappalti from './pages/app/Subappalti';
import Fatture from './pages/app/Fatture';
import AutoPilot from './pages/app/AutoPilot';
import AgentiAI from './pages/app/AgentiAI';
import LeadConversations from './pages/app/LeadConversations';
import Profilo from './pages/app/Profilo';
import PrivacyPolicy from './pages/legal/PrivacyPolicy';
import CookiePolicy from './pages/legal/CookiePolicy';
import TermsOfService from './pages/legal/TermsOfService';
import InstallApp from './pages/InstallApp';
import AnalyticsPage from './pages/app/AnalyticsPage';
import AdminFirma from './pages/app/AdminFirma';
import AdminProfessionisti from './pages/app/AdminProfessionisti';
import PublicDvr from './pages/PublicDvr';
import DvrGrazie from './pages/DvrGrazie';
import DvrComeFunziona from './pages/DvrComeFunziona';
import PublicQuote from './pages/PublicQuote';
import PublicProforma from './pages/PublicProforma';
import PublicFattura from './pages/PublicFattura';
import { CookieBanner } from './components/CookieBanner';
import './App.css';

function Protected({ children }) {
    const { user, loading } = useAuth();
    if (loading) return <div className="min-h-screen flex items-center justify-center">Caricamento…</div>;
    if (!user) return <Navigate to="/login" replace />;
    if (!user.onboarding_complete) return <Navigate to="/onboarding" replace />;
    return children;
}

function App() {
    return (
        <AuthProvider>
            <BrowserRouter>
                <Toaster richColors position="top-right" />
                <PWAInstallPrompt />
                <CookieBanner />
                <Routes>
                    <Route path="/" element={<Landing />} />
                    <Route path="/checkout" element={<Checkout />} />
                    <Route path="/checkout/success" element={<CheckoutSuccess />} />
                    <Route path="/login" element={<Login />} />
                    <Route path="/forgot-password" element={<ForgotPassword />} />
                    <Route path="/reset-password" element={<ResetPassword />} />
                    <Route path="/onboarding" element={<Onboarding />} />
                    <Route path="/privacy" element={<PrivacyPolicy />} />
                    <Route path="/cookies" element={<CookiePolicy />} />
                    <Route path="/terms" element={<TermsOfService />} />
                    <Route path="/install" element={<InstallApp />} />
                    <Route path="/p/:token" element={<PublicQuote />} />
                    <Route path="/p/proforma/:token" element={<PublicProforma />} />
                    <Route path="/p/fattura/:token" element={<PublicFattura />} />
                    <Route path="/dvr" element={<PublicDvr />} />
                    <Route path="/dvr/grazie" element={<DvrGrazie />} />
                    <Route path="/dvr/come-funziona" element={<DvrComeFunziona />} />
                    <Route path="/app" element={<Protected><AppShell /></Protected>}>
                        <Route index element={<Navigate to="dashboard" replace />} />
                        <Route path="dashboard" element={<Dashboard />} />
                        <Route path="preventivi" element={<Preventivi />} />
                        <Route path="sal" element={<SAL />} />
                        <Route path="sicurezza" element={<Sicurezza />} />
                        <Route path="subappalti" element={<Subappalti />} />
                        <Route path="fatture" element={<Fatture />} />
                        <Route path="forza-vendita" element={<Navigate to="/app/agenti?tab=crm" replace />} />
                        <Route path="agenti" element={<AgentiAI />} />
                        <Route path="lead-conversations" element={<LeadConversations />} />
                        <Route path="profilo" element={<Profilo />} />
                        <Route path="admin/analytics" element={<AnalyticsPage />} />
                        <Route path="admin/firma" element={<AdminFirma />} />
                        <Route path="admin/professionisti" element={<AdminProfessionisti />} />
                    </Route>
                    <Route path="*" element={<Navigate to="/" replace />} />
                </Routes>
            </BrowserRouter>
        </AuthProvider>
    );
}

export default App;
